import Image from 'app/Components/Shared/Image/image';
import React from "react";
import {getMarketCode} from 'app/utilities/domain/domainConstants';

export const InfoPopUp = () => {
    const marketCode = getMarketCode().toLowerCase();
    return (
        <div className={'info-container'}>
            <span>מספר ה- SIM מופיע בגב הכרטיס, ממש כאן</span>
            <Image src={require(`../images/sim-info-${marketCode}.png`)} alt={"sim-info"} />
        </div>
    )
}